export default function getDepartmentsOptions(options: Record<string, any[]>) {
    return (options?.departments ?? []).filter(item => !item.is_outsource);
}
